module.exports = __webpack_public_path__ + "img/system20-mini.2f5f16ce.png";